import URL from 'url';

const utmParameters = [
    'referrerType',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'utm_campaign',
];

export const GoogleActUTMParams = {
    referrerType: 'GoogleAct',
    utm_source: 'google',
    utm_medium: 'googlewidget',
};

export const createUtmURL = (base, parameters = {}) => {
    const url = URL.parse(base, true);
    delete url.search;
    utmParameters.forEach(param => {
        if (parameters[param]) {
            url.query[param] = parameters[param];
        } else {
            delete url.query[param];
        }
    });
    return URL.format(url);
};

export default createUtmURL;
